!((document, Drupal, $) => {
  'use strict';
  Drupal.behaviors.eventCarousel = {

    /* eslint-disable max-len */
    // Previous Arrow markup is used more than once.
    // Define it once here.
    prevArrow: `<button type="button" class="upcoming-events__btn btn btn--circle prev" aria-label="Back up the gallery">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.3 26.7"><path d="M1 13.4L13.5.9l3.7 3.7-8.7 8.8 8.7 8.7-3.7 3.8z"/></svg>
                </button>`,

    // Next Arrow markup is used more than once.
    // Define it once here.
    nextArrow: `<button type="button" class="upcoming-events__btn btn btn--circle next" aria-label="Advance the gallery">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.3 26.7"><path d="M17.2 13.4L4.7 25.9 1 22.1l8.8-8.7L1 4.6 4.7.9z"/></svg>
                </button>`,
    /* eslint-enable max-len */

    attach: function (context) {

      $('.upcoming-events', context).not('.slick-initialized').slick({
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: false,
        dots: false,
        prevArrow: this.prevArrow,
        nextArrow: this.nextArrow,
        appendArrows: $('.upcoming-events__pager'),
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 6
            }
          },
        ]
      });
    }
  };
})(document, Drupal, jQuery);
